<div class="overlay" (click)="toggleModal()"></div>
<div class="container flex-column m-0 p-0 d-flex">
  <div class="row g-0 m-0 p-4 justify-content-start borderb">
    <div class="col-md-11 ps-2 d-flex justify-content-start">
      <span class="popup-title">{{ "MANUAL_CONNECTIVITY_DIAGNOSTICS" | translate }}</span>
    </div>
    <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
      <svg-icon alt="Exit" class="exit" role="button" src="assets/device/exit.svg"></svg-icon>
    </div>
  </div>

  <div class="row g-0 m-0 px-4 pt-3 align-items-center">
    <div class="col ps-2">
      <span class="popup-subtitle">{{ "ANALYSIS_STREAM" | translate }}</span>
    </div>
    @if (isRunning) {
    <div class="col-auto pe-2 d-flex align-items-center gap-2">
      <span class="gathering-text">{{ "DIAGNOSTICS_GATHERING" | translate }}</span>
      <span class="loading-dots">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </span>
    </div>
    }
  </div>

  <div class="row g-0 m-0 body mt-2 mb-3">
    <div class="steps-container px-4">
      @for (row of stepViews; track row.labelKey; let last = $last) {
      <div class="step-card">
        <svg-icon class="step-icon"
          [src]="row.results.length ? 'assets/result.svg' : 'assets/pending.svg'"></svg-icon>

        <div class="step-content">
          <span class="step-name">{{ row.labelKey | translate }}</span>

          @for (result of row.results; track result.step) {
          <div class="step-result">
            @if (isTelemetryStep(result)) {
            <span class="step-meta step-summary">
              {{ "DIAGNOSTICS_TELEMETRY_SUMMARY" | translate: {
                actual: result.actualReadCount ?? 0,
                missing: missingReads(result),
                expected: result.expectedReadCount ?? 0
              } }}
            </span>
            } @else if (isSweepStep(result)) {
            <span class="step-meta step-summary">
              {{ "DIAGNOSTICS_SWEEP_SUMMARY" | translate: {
                scanned: result.scannedCount ?? 0,
                asset: result.assetName ?? '',
                meterNumber: result.meterNumber,
                failed: result.failedCount ?? 0
              } }}
            </span>
            } @else {
            <span class="step-meta">
              <span class="step-meta-label">{{ labelKeyFor(result) | translate }}</span>
              @if (isHierarchyStep(result)) {
              {{ result.assetType }} {{ result.meterNumber }}
              } @else {
              {{ result.meterNumber }}
              }
            </span>
            }
            <span class="step-pill" [class.failed]="isFailed(result)" [class.success]="!isFailed(result)">
              <span class="pill-dot"></span>
              @if (isTelemetryStep(result)) {
              {{ "DIAGNOSTICS_FAILED_READS" | translate: { missing: missingReads(result) } }}
              } @else if (isSweepStep(result)) {
              {{ "DIAGNOSTICS_METERS_DOWN" | translate: { failed: result.failedCount ?? 0 } }}
              } @else {
              {{ getStepStatusKey(result) | translate }}
              }
            </span>
          </div>

          @if (!isHierarchyStep(result) && !isTelemetryStep(result) && !isSweepStep(result)) {
          @if (result.endpoint) {
          <span class="step-meta">
            <span class="step-meta-label">{{ "DIAGNOSTICS_ENDPOINT" | translate }}</span>
            {{ result.endpoint }}
          </span>
          }
          }

          @if (result.lastCommunicationTime && !isHierarchyStep(result) && !isSweepStep(result)) {
          <span class="step-meta">
            <span class="step-meta-label">{{ "DIAGNOSTICS_LAST_COMMUNICATION" | translate }}</span>
            {{ result.lastCommunicationTime | date: 'dd MMM yyyy, h:mm a' }}
          </span>
          }

          @if (result.error?.message) {
          <span class="step-detail">{{ result.error!.message }}</span>
          }
          }
        </div>
      </div>

      @if (!last) {
      <div class="step-connector"></div>
      }
      }
    </div>
  </div>

  <div class="row g-0 m-0 p-3 align-items-center bordert footer-row">
    <div class="col-md-4 pt-2 pb-2 ps-2 d-flex justify-content-start" (click)="toggleModal()">
      <span role="button" class="item-name">{{ "CLOSE_WINDOW" | translate }}</span>
    </div>
  </div>
</div>
